<template>
  <div class="rwa_mint_div">

    <div class="rwa_mint_page_01">
      <Menu/>
    </div>

    <div class="rwa_mint_page_02">

      <img class="rwa_mint_page_02_bj01" src="../../assets/images/yusbj1.png"/>
      <img class="rwa_mint_page_02_bj02" src="../../assets/images/yusbj2.png"/>

      <div class="rwa_mint_page_021">
        <div class="rwa_mint_page_0211" @click="toHomePage()">
          <img src="../../assets/images/fhjt.png"/>
          {{ lang('home') }}
        </div>

        <div class="rwa_mint_page_0212">

          <div class="rwa_mint_page_02120s">
            <div class="rwa_mint_page_02120s1">
              <img class="rwa_mint_page_02120s11" src="../../assets/images/yusbj.png"/>

              <div class="rwa_mint_page_02120s12">
                <img src="../../assets/images/daibi.png"/>
                <span>铸造规则</span>
              </div>

              <div class="rwa_mint_page_02120s13">
                <div class="rwa_mint_page_02120s131">
                  <div class="rwa_mint_page_02120s1311">•</div>
                  <div class="rwa_mint_page_02120s1312">新币 {{mintConfigData.mintTokenName}} 的 2% 代币总量</div>
                </div>
              </div>

              <div class="rwa_mint_page_02120s13">
                <div class="rwa_mint_page_02120s131">
                  <div class="rwa_mint_page_02120s1311">•</div>
                  <div class="rwa_mint_page_02120s1312">每人最多投入 {{mintConfigData.maxShare}} 份，{{mintConfigData.shareNum}} 个Bucoin为1份</div>
                </div>
              </div>

              <div class="rwa_mint_page_02120s12">
                <img src="../../assets/images/daibi.png"/>
                <span>代币介绍</span>
              </div>
              <div class="rwa_mint_page_02120s14">
                {{ mintConfigData.tokenOverview }}
              </div>
            </div>

            <div class="rwa_mint_page_02120s2">
              <div class="rwa_mint_page_02120s21">
                <img src="../../assets/images/bodong.png"/>
                <span>结束倒计时</span>
                <div class="rwa_mint_page_02120s211">
                  <div>{{ shi }}</div>
                  :
                  <div>{{ fen }}</div>
                  :
                  <div>{{ miao }}</div>
                </div>
              </div>

              <div class="rwa_mint_page_02120s22">
                <div class="rwa_mint_page_02120s221">
                  <div class="rwa_mint_page_02120s2211">
                    <img src="../../assets/images/ryuan.png"/>
                    <span>参与人数</span>
                  </div>
                  <div class="rwa_mint_page_02120s2212">
                    {{ participantsNum }}
                  </div>
                </div>

                <div class="rwa_mint_page_02120s221 rwa_mint_page_02120s221_mob">
                  <div class="rwa_mint_page_02120s2211">
                    <img src="../../assets/images/myuan.png"/>
                    <span>总投入</span>
                  </div>
                  <div class="rwa_mint_page_02120s2212">
                    {{ (totalStaked > 1000) ? (setDecimal(totalStaked / 1000, 3) + ' K') : setDecimal(formatNumberKx(totalStaked, 6), 6) }} {{ mintConfigData.stakeTokenName }}
                  </div>
                </div>
              </div>

              <div class="rwa_mint_page_02120s23">
                <div class="rwa_mint_page_02120s231">
                  <span>铸造进度</span>
                  <div>{{ setDecimal((totalStakedNum / mintConfigData.hardCap) * 100, 2) }} %</div>
                </div>

                <div class="rwa_mint_page_02120s232">
                  <el-progress
                      :text-inside="true"
                      :stroke-width="20"
                      :percentage="parseFloat(setDecimal((totalStakedNum / mintConfigData.hardCap) * 100, 2))"
                      status="success"
                      define-back-color="#01FF8833"
                      text-color="#ffffff"
                      color="#00FF88">
                  </el-progress>
                </div>

                <div class="rwa_mint_page_02120s233">
                  <div>当前: {{ totalStakedNum }}</div>
<!--                  <div>软顶: {{ mintConfigData.softCap }}</div>-->
                  <div>硬顶: {{ mintConfigData.hardCap }}</div>
                </div>
              </div>

              <div class="rwa_mint_page_02120s24">
                <div class="rwa_mint_page_02120s241">
                  投入代币数量
                </div>

                <div class="rwa_mint_page_02120s242">
                  <el-input-number
                      v-model="mintNum"
                      controls-position="right"
                      @change="handleChangeMint"
                      :step="mintConfigData.shareNum"
                      :min="mintConfigData.shareNum"
                      :max="mintConfigData.maxShare * mintConfigData.shareNum">
                  </el-input-number>
                </div>

                <div class="rwa_mint_page_02120s243">
                  代币余额<span> {{ myBalance }} {{ mintConfigData.stakeTokenName }}</span>
                </div>
                <div class="rwa_mint_page_02120s243">
                  我投入的代币量<span> {{ setDecimal(formatNumberKx(myTokenStake, 6), 6) }} {{ mintConfigData.stakeTokenName }}</span>
                </div>
              </div>

              <div class="rwa_mint_page_02120s25"
                   v-if="
                   $store.state.accounts.length <= 0
                   &&
                   this.mintConfigData.endTime > new Date().getTime() / 1000"
                   @click="toConnectWalletMining()">
                请先连接钱包
              </div>

              <div class="rwa_mint_page_02120s25"
                   v-if="
                   $store.state.accounts.length > 0
                   &&
                   this.mintConfigData.endTime > new Date().getTime() / 1000
                   &&
                   myTokenStakeNum < mintConfigData.maxShare
                   &&
                   totalStakedNum < mintConfigData.hardCap
                   &&
                   userApproveNum < mintConfigData.shareNum"
                   @click="toUserApprove()">
                授权
              </div>

              <div class="rwa_mint_page_02120s25" style="background: #5a5a5a; cursor: not-allowed"
                   v-if="
                   $store.state.accounts.length > 0
                   &&
                   this.mintConfigData.endTime > new Date().getTime() / 1000
                   &&
                   (myTokenStakeNum >= mintConfigData.maxShare
                   ||
                   totalStakedNum >= mintConfigData.hardCap)">
                参与
              </div>

              <div class="rwa_mint_page_02120s25"
                   v-if="
                   $store.state.accounts.length > 0
                   &&
                   this.mintConfigData.endTime > new Date().getTime() / 1000
                   &&
                   myTokenStakeNum < mintConfigData.maxShare
                   &&
                   totalStakedNum < mintConfigData.hardCap
                   &&
                   userApproveNum >= mintConfigData.shareNum"
                   @click="onDepBuCoin()">
                参与
              </div>

              <div class="rwa_mint_page_02120s25" style="background: #5a5a5a; cursor: not-allowed"
                   v-if="this.mintConfigData.endTime <= new Date().getTime() / 1000">
                已结束
              </div>
            </div>
          </div>

          <div class="rwa_mint_page_02123">
            <div class="rwa_mint_page_021230">
              <img src="../../assets/images/lisisj.png"/>
              <span>交易记录</span>
            </div>

            <div class="rwa_mint_page_021231">
              <div class="rwa_mint_page_0212311">
                <div class="mint_page_0212311_title0">地址</div>
                <div class="mint_page_0212311_title0">数量</div>
                <div class="mint_page_0212311_title0">状态</div>
                <div class="mint_page_0212311_title1">时间</div>
              </div>
              <div class="rwa_mint_page_0212312s_rows" v-if="transactionHistory.length > 0">
                <div class="rwa_mint_page_0212312s" v-for="(obj, index) in transactionHistory" :key="index">
                  <div class="mint_page_0212312s_row0">{{ cutAccount(obj.user, 3) }}</div>
                  <div class="mint_page_0212312s_row0">{{ obj.num * mintConfigData.shareNum }} {{ mintConfigData.stakeTokenName }}</div>
                  <div class="mint_page_0212312s_row0">
                    <el-tag v-if="obj.num > 0"  type="success" effect="light" size="small" color="rgba(0, 201, 80, 0.20)" :hit="true">
                      已完成
                    </el-tag>
                    <el-tag v-if="obj.num === 0" type="danger" effect="light" size="small" color="rgba(255, 100, 103, 0.20)" :hit="true">
                      &nbsp;失&nbsp; 败&nbsp;
                    </el-tag>
                  </div>
                  <div class="mint_page_0212312s_row1">{{ toTextDate(obj.time) }}</div>
                </div>
              </div>
              <div class="rwa_mint_page_0212312s_rows_not_data" v-if="transactionHistory.length <= 0">
                {{ isTransactionHistoryLoding ? lang('jzz') : lang('zwsj') }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="rwa_mint_page_03">
        <Bottom/>
      </div>
    </div>

  </div>
</template>

<script>
import Menu from "@/components/Menu.vue";
import Bottom from "@/components/Bottom.vue";
import { cutAccount, lang, BigNumberMul } from "@/tools";
import toolUtils, { setDecimal, formatNumberKx, conversionTimestampFormatObj } from "@/tools/toolUtils";
import { mixin1 } from "@/tools/mixins";
import * as metaMaskTools from "@/tools/chain";
import transfer from "@/tools/transfer";

export default {
  name: "Mint",
  components: {
    Menu,
    Bottom
  },
  mixins: [mixin1],
  data() {
    return {
      projectId: 0,
      participantsNum: 0, // 参与人数
      totalStaked: 0, // 总投入
      totalStakedNum: 0, // 总投入份数
      myBalance: 0, // 代币余额
      myTokenStake: 0, // 我投入的代币量
      myTokenStakeNum: 0, // 我投入的代币份数
      userApproveNum: 0, // 用户授权数量
      mintNum: 0, // 铸造数量
      isTransactionHistoryLoding: false,
      transactionHistory: [],
      shi: 0,
      fen: 0,
      miao: 0,
      launchAddress: null,
      mintConfigData: {
        projectId: 0, // 项目ID
        mintTokenName: null, // 代币名称
        mintTokenAddress: null, // 代币地址
        stakeTokenName: 'Bucoin', // 抵押代币名称
        stakeTokenAddress: '0x4e86BFa3376eC576053139d56779f983678f8ba8', // 抵押代币地址
        startBlockNum: 0, // 开始区块号
        queryBlockNum: 150000, // 扫描区块数
        startTime: 0, // 开始时间戳
        endTime: 0, // 结束时间戳
        maxShare: 0, // 最大份数
        shareNum: 0, // 份数对应数量
        softCap: 0, // 软顶
        hardCap: 0, // 硬顶
        tokenOverview: null
      },
      countdownMintInterval: null,
      isFetchingTokenInfo: false,  // 标记方法是否正在执行
      tokenInfoInterval: null      // 存储定时器ID
    };
  },
  watch: {},
  created() {
    this.projectId = this.$route.query.projectId;
    this.mintConfigData.projectId = this.$route.query.projectId;
    this.launchAddress = this.$route.query.tokenAddress;
    this.mintConfigData.mintTokenAddress = this.$route.query.tokenAddress;

    setTimeout(() => {
      this.onAccountsChanged();
    }, 1000);
  },
  mounted() {
    // 立即执行一次
    this.countdownToEnd();

    // 设置定时器，每隔1秒执行一次
    this.countdownMintInterval = setInterval(() => {
      this.countdownToEnd();
    }, 1000);

    setTimeout(() => {
      this.mintNum = this.mintConfigData.shareNum;
    }, 1000);

    this.initMintData();

    // 设置定时器，每隔5秒执行一次
    this.tokenInfoInterval = setInterval(() => {
      if (!this.isFetchingTokenInfo) {
        this.executeTokenInfoFetch();
      }
    }, 5000);
  },
  destroyed() {
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.countdownMintInterval) {
      clearInterval(this.countdownMintInterval);
      this.countdownMintInterval = null;
    }
    if (this.tokenInfoInterval) {
      clearInterval(this.tokenInfoInterval);
    }
  },
  methods: {
    lang(key){
      return lang(key);
    },
    cutAccount(account, num) {
      return cutAccount(account, num);
    },
    setDecimal(num, numDecimalMax) {
      return setDecimal(num, numDecimalMax, false, false);
    },
    copyValue(val) {
      if (val) {
        toolUtils.copyValue(val);
        this.$message.success(lang('fzcg'));
      } else {
        this.$message.error(lang('myfzrhnr'));
      }
    },
    formatNumberKx(num, decimals) {
      return formatNumberKx(num, decimals);
    },
    toTextDate(time) {
      return toolUtils.toTextDate(time);
    },
    getSecondsPassedToday() {
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      const seconds = now.getSeconds();

      return hours * 3600 + minutes * 60 + seconds;
    },

    /**
     * 返回首页
     */
    toHomePage() {
      transfer.$emit("toMenuPage", 1);
    },
    async initRefreshNetwork() {
      await metaMaskTools.initParams().then(() => {});
    },
    async onRefresh(accounts) {
      await this.$store.commit('setState', {
        accounts
      });

      await this.initMintData();
    },
    openConnectWallet() {
      this.$store.commit('setState', {
        connectWalletShow: true
      });
    },
    toConnectWalletMining() {
      this.$message.warning(lang('qxljqb'));

      this.openConnectWallet();
    },
    /**
     * 重置页面数据
     */
    resetMintData() {
      this.myBalance = 0;
      this.myTokenStake = 0;
    },
    /**
     * 初始化页面数据
     */
    async getInitMintData() {
      this.projectId = this.$route.query.projectId;
      this.mintConfigData.projectId = this.$route.query.projectId;
      this.launchAddress = this.$route.query.tokenAddress;
      this.mintConfigData.mintTokenAddress = this.$route.query.tokenAddress;
    },
    /**
     * 刷新页面数据
     * @returns {Promise<void>}
     */
    async initMintData() {
      await this.getInitMintData();

      await this.getArtlaunchTokenInfo();
      await this.getMyBalance();
      await this.getTokenInfo();
      await this.getUserInfo();
      await this.queryUserAllowance();

      await this.getDepBuCoin();
    },
    async executeTokenInfoFetch() {
      this.isFetchingTokenInfo = true;
      try {
        if (this.mintConfigData.endTime >= (new Date().getTime() / 1000)
            &&
            this.totalStakedNum < this.mintConfigData.hardCap
        ) {
          await this.getTokenInfo();
        }
      } catch (error) {
        console.error('Error fetching token info:', error);
      } finally {
        this.isFetchingTokenInfo = false;
      }
    },
    /**
     * 倒计时
     */
    countdownToEnd() {
      if (this.mintConfigData && this.mintConfigData.endTime) {
        let time = this.mintConfigData.endTime - new Date().getTime() / 1000;
        if (time < 0) {
          time = 0;
        }

        let timeObj = conversionTimestampFormatObj(time);

        this.shi = parseInt(timeObj.tian) * 24 + parseInt(timeObj.shi);
        if (this.shi < 10) {
          this.shi = '0' + this.shi;
        }
        this.fen = timeObj.fen;
        this.miao = timeObj.miao.toString().substring(0, 2);
      }
    },
    async getMyBalance() {
      try {
        if (this.$store.state.accounts.length > 0) {
          await metaMaskTools.erc20BasicPublicCall(
              this.mintConfigData.stakeTokenAddress,
              'balanceOf',
              [this.$store.state.accounts[0]]
          ).then(async (res) => {
            if (res) {
              this.myBalance = this.setDecimal(res / 1e18, 3);
            }
          }).catch((err) => {
            console.log(err);
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * 获取代币的完整信息（包含扩展信息）
     * @returns {Promise<void>}
     */
    async getArtlaunchTokenInfo() {
      try {
        await this.$http.getTokenArtlaunch(this.launchAddress).then(async (res) => {
          if (res.success) {
            this.mintConfigData.mintTokenName = res.data.token_symbol;
            this.mintConfigData.startBlockNum = res.data.block_number ? parseInt(res.data.block_number) : 0;
            this.mintConfigData.tokenOverview = res.data.description;
          }
        }).catch((err) => {
          console.log(err);
        });
      } catch (e) {
        console.log(e);
      }
    },
    /**
     * 获取项目Mint信息
     * @returns {Promise<void>}
     */
    async getTokenInfo() {
      try {
        await metaMaskTools.getTokenInfo(this.launchAddress, []).then(async (res) => {
          console.log(res);
          if (res) {
            this.totalStaked = this.setDecimal(res.totalBucoin / 1e18, 3);
            this.totalStakedNum = res.totalNum;
            this.participantsNum = res.totalAddress;

            this.mintConfigData.endTime = parseInt(res.endTime);
            // this.mintConfigData.softCap = parseInt(res.softTop);
            this.mintConfigData.hardCap = parseInt(res.hardTop);
            this.mintConfigData.maxShare = parseInt(res.perAddressMax);
            this.mintConfigData.shareNum = parseInt(this.setDecimal(res.bucoinAmountForEach / 1e18, 3));
          }
        }).catch((err) => {
          console.log(err);
        });
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * 获取用户Mint信息
     * @returns {Promise<void>}
     */
    async getUserInfo() {
      try {
        if (this.$store.state.accounts.length > 0) {
          await metaMaskTools.getUserInfo(this.launchAddress, [this.$store.state.accounts[0]]).then(async (res) => {
            console.log(res);
            if (res) {
              this.myTokenStake = this.setDecimal(res.totalBucoin / 1e18, 3);
              this.myTokenStakeNum = parseInt(res.totalNum);
            }
          }).catch((err) => {
            console.log(err);
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * 参与抵押 Mint
     * @param value
     */
    handleChangeMint(value) {
      console.log(value);
    },
    /**
     * 查询用户授权
     */
    async queryUserAllowance() {
      if (this.$store.state.accounts.length > 0) {
        try {
          await metaMaskTools.erc20BasicPublicCall(
              this.mintConfigData.stakeTokenAddress,
              'allowance',
              [this.$store.state.accounts[0], this.launchAddress]
          ).then(async (res) => {
            console.log(res);
            if (res) {
              this.userApproveNum = parseFloat(this.setDecimal(res / 1e18, 3));
            }
          }).catch((err) => {
            console.log(err);
          });
        } catch (error) {
          console.log(error);
        }
      }
    },
    /**
     * 用户授权
     */
    async toUserApprove() {
      if (this.$store.state.accounts.length > 0) {
        try {
          if (
              this.mintConfigData.maxShare
              &&
              this.mintConfigData.shareNum
          ) {
            let approveNum = this.mintConfigData.maxShare * this.mintConfigData.shareNum;
            approveNum = BigNumberMul(approveNum, 1e18, 0);

            await metaMaskTools.erc20BasicPublicSend(
                this.mintConfigData.stakeTokenAddress,
                'approve',
                [this.launchAddress, approveNum]
            ).then(async (res) => {
              console.log(res);
              if (res) {
                await this.queryUserAllowance();
              }
            }).catch((err) => {
              console.log(err);
            });
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    /**
     * 参与抵押 Mint
     */
    async onDepBuCoin() {
      try {
        if (this.$store.state.accounts.length > 0) {
          let num;
          if (this.mintNum && this.mintNum > 0 && this.mintConfigData.shareNum) {
            num = this.mintNum / this.mintConfigData.shareNum;
          }
          console.log(num);

          if (num > (this.mintConfigData.maxShare - this.myTokenStakeNum)) {
            this.$message.warning('Exceeding the participation limit!');
            return;
          }

          await metaMaskTools.onDepBuCoin(this.launchAddress, [num]).then(async (res) => {
            if (res) {
              console.log(res);

              await this.initMintData();
            }
          }).catch((err) => {
            console.log(err);
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getDepBuCoin() {
      try {
        this.isTransactionHistoryLoding = true;

        if (this.$store.state.accounts.length > 0) {
          let fromBlock = this.mintConfigData.startBlockNum;
          let blockNum = this.mintConfigData.queryBlockNum;

          let toBlock;
          await metaMaskTools.getIndexBlock().then(async (res) => {
            if (res) {
              toBlock = parseInt(res);
            }
          }).catch((err) => {
            console.log(err);
          });

          if (toBlock) {
            if (toBlock > fromBlock + blockNum) {
              toBlock = fromBlock + blockNum;
            }
            console.log("fromBlock: " + fromBlock);
            console.log("toBlock: " + toBlock);

            if (fromBlock && toBlock) {
              let transactionHistoryData = [];

              // 每10000区块查询一次
              for (let i = fromBlock; i <= toBlock; i = i+10000) {
                await metaMaskTools.getDepBuCoin(
                    this.launchAddress,
                    this.mintConfigData.projectId,
                    this.$store.state.accounts[0],
                    i,
                    i+10000 > toBlock ? toBlock : i+9999
                ).then(async (res) => {
                  console.log(res);
                  if (res && res.length > 0) {
                    for (let j = 0; j < res.length; j++) {
                      transactionHistoryData.push(res[j].returnValues);
                    }
                  }
                }).catch((err) => {
                  console.log(err);
                });
              }

              this.transactionHistory = transactionHistoryData;
              console.log(this.transactionHistory);
            }
          }
        }
        this.isTransactionHistoryLoding = false;
      } catch (error) {
        console.log(error);
        this.isTransactionHistoryLoding = false;
      }
    }
  },
};
</script>

<style scoped lang="less">
.rwa_mint_div {
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;

  .rwa_mint_page_01 {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .rwa_mint_page_02::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  .rwa_mint_page_02 {
    overflow-y: auto;
    position: absolute;
    width: 100%;
    top: 84px;
    bottom: 0;
    background: #151515;
    .rwa_mint_page_02_bj01 {
      position: absolute;
      top: 0;
      left: 0;
      width: 50%;

      @media (max-width: 767px) {
        display: none;
      }
    }
    .rwa_mint_page_02_bj02 {
      position: absolute;
      top: 0;
      right: 0;
      width: 65%;

      @media (max-width: 767px) {
        width: 100%;
      }
    }
    .rwa_mint_page_02_bj03 {
      display: none;

      @media (max-width: 767px) {
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 60%;
      }
    }
    .rwa_mint_page_021 {
      position: relative;
      width: 80%;
      margin-left: 10%;
      .rwa_mint_page_0211 {
        width: 150px;
        color: #FFF;
        font-family: Montserrat;
        font-size: 26px;
        font-style: italic;
        font-weight: 900;
        line-height: 152%; /* 39.52px */
        margin: 100px 0 50px 0;
        cursor: pointer;
        img {
          margin-right: 10px;
          margin-bottom: 3px;
        }
      }
      .rwa_mint_page_0212 {
        width: 100%;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: flex-start;
        padding: 20px;
        margin-bottom: 200px;

        border-radius: 12px;
        border: 0.5px solid rgba(153, 153, 153, 0.30);
        background: rgba(49, 49, 49, 0.40);
        box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.10);

        @media (max-width: 767px) {
          padding: 0;
          border-radius: 0;
          border: 0;
          background: 0;
          margin-bottom: 150px;
        }
        .rwa_mint_page_02120s {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          justify-content: space-between;
          align-items: flex-start;
          width: 100%;
          border-radius: 12px;
          margin-bottom: 30px;

          @media (max-width: 767px) {
            flex-direction: column;
            justify-content: flex-start;
          }
          .rwa_mint_page_02120s1 {
            width: 49%;
            border-radius: 8px;
            border: 0.5px solid rgba(153, 153, 153, 0.30);
            background: #252525;
            padding: 15px;

            @media (max-width: 767px) {
              width: 100%;
              margin-bottom: 20px;
            }
            .rwa_mint_page_02120s11 {
              width: 100%;
            }
            .rwa_mint_page_02120s12 {
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              justify-content: flex-start;
              align-items: center;
              margin: 20px 0 15px 0;
              img {
                width: 20px;
                margin-right: 8px;
              }
              span {
                color: #05DF72;
                font-family: Arial;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 24px; /* 150% */
              }
            }
            .rwa_mint_page_02120s13 {
              margin: 5px 0;
              .rwa_mint_page_02120s131 {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                justify-content: flex-start;
                align-items: flex-start;
                .rwa_mint_page_02120s1311 {
                  color: #05DF72;
                  font-family: Arial;
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 30px; /* 150% */
                  margin-right: 5px;
                }
                .rwa_mint_page_02120s1312 {
                  width: fit-content;
                  color: #D1D5DC;
                  font-family: Arial;
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 30px; /* 150% */
                }
              }
            }
            .rwa_mint_page_02120s14 {
              color: #D1D5DC;
              font-family: Arial;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 30px; /* 150% */
            }
          }
          .rwa_mint_page_02120s2 {
            width: 49%;
            display: flex;
            flex-direction: column;
            flex-wrap: nowrap;
            align-items: flex-start;
            justify-content: flex-start;

            @media (max-width: 767px) {
              width: 100%;
              margin-bottom: 20px;
            }
            .rwa_mint_page_02120s21 {
              width: 100%;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: center;
              border-radius: 8px;
              border: 1px solid rgba(0, 201, 80, 0.20);
              background: rgba(0, 201, 80, 0.05);
              padding: 10px 17px;
              margin-bottom: 16px;
              img {
                width: 20px;
              }
              span {
                color: #999;
                font-family: Arial;
                font-size: 15px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                margin: 0 10px;
              }
              .rwa_mint_page_02120s211 {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                justify-content: center;
                align-items: center;
                color: #FFF;
                font-family: Roboto;
                font-size: 20px;
                font-style: normal;
                font-weight: 700;
                line-height: 28px; /* 140% */
                div {
                  color: #FFF;
                  font-family: Roboto;
                  font-size: 20px;
                  font-style: normal;
                  font-weight: 700;
                  line-height: 28px; /* 140% */
                  border-radius: 4px;
                  background: #344B40;
                  width: 30px;
                  text-align: center;
                  margin: 0 5px;
                }
              }
            }
            .rwa_mint_page_02120s22 {
              width: 100%;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 16px;

              @media (max-width: 767px) {
                align-items: stretch;
              }
              .rwa_mint_page_02120s221_mob {
                @media (max-width: 767px) {
                  width: 60% !important;
                }
              }
              .rwa_mint_page_02120s221 {
                width: 49%;
                border-radius: 8px;
                border: 1px solid rgba(0, 201, 80, 0.20);
                background: rgba(0, 201, 80, 0.05);
                padding: 17px;

                @media (max-width: 767px) {
                  width: 38%;
                }
                .rwa_mint_page_02120s2211 {
                  display: flex;
                  flex-direction: row;
                  flex-wrap: nowrap;
                  justify-content: flex-start;
                  align-items: center;
                  img {
                    width: 20px;
                    margin-right: 5px;
                    margin-bottom: 5px;
                  }
                  span {
                    color: #999;
                    font-family: Arial;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 20px; /* 142.857% */
                  }
                }
                .rwa_mint_page_02120s2212 {
                  color: #05DF72;
                  font-family: Arial;
                  font-size: 24px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 32px; /* 133.333% */
                }
              }
            }
            .rwa_mint_page_02120s23 {
              width: 100%;
              border-radius: 8px;
              border: 1px solid rgba(0, 201, 80, 0.20);
              background: rgba(0, 201, 80, 0.05);
              padding: 17px;
              margin-bottom: 16px;
              .rwa_mint_page_02120s231 {
                width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                span {
                  color: #999;
                  font-family: Arial;
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 24px; /* 150% */
                }
                div {
                  color: #05DF72;
                  font-family: Arial;
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 24px; /* 150% */
                }
              }
              .rwa_mint_page_02120s232 {
                width: 100%;
                margin: 8px 0;
              }
              .rwa_mint_page_02120s233 {
                width: 100%;
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                align-items: center;
                justify-content: space-between;
                div {
                  color: #666;
                  font-family: Arial;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 20px; /* 142.857% */
                }
              }
            }
            .rwa_mint_page_02120s24 {
              width: 100%;
              margin: 10px 0 25px 0;
              .rwa_mint_page_02120s241 {
                color: #999;
                font-family: Arial;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 24px; /* 150% */
                margin-bottom: 15px;
              }
              .rwa_mint_page_02120s242 {
                width: 100%;
                margin-bottom: 15px;

                @media (max-width: 767px) {
                  zoom: 1.25;
                }
              }
              .rwa_mint_page_02120s243 {
                color: #999;
                font-family: Arial;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 24px; /* 171.429% */
                margin: 8px 0 0 0;
                span {
                  color: #05DF72;
                  font-family: Arial;
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: normal;
                }
              }
            }
            .rwa_mint_page_02120s25 {
              display: flex;
              width: 100%;
              height: 48px;
              padding: 13px 0 15px 0;
              justify-content: center;
              align-items: center;
              border-radius: 6px;
              color: white;
              background: #20944B;
              box-shadow: 0 0 15px 0 rgba(0, 255, 136, 0.60);
              cursor: pointer;
            }
          }
        }
        .rwa_mint_page_02123 {
          border-radius: 8px;
          border: 0.5px solid rgba(153, 153, 153, 0.30);
          background: #252525;
          width: 100%;
          margin-bottom: 15px;
          padding: 15px;

          @media (max-width: 767px) {
            width: 100%;
            margin-bottom: 10px;
          }
          .rwa_mint_page_021230 {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 15px;
            img {
              width: 20px;
            }
            span {
              color: #FFF;
              font-family: Arial;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 24px; /* 150% */
            }
          }
          .rwa_mint_page_021231 {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            align-self: stretch;
            border-radius: 8px;
            border: 1px solid rgba(96, 96, 96, 0.20);
            .rwa_mint_page_0212311 {
              width: 100%;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              justify-content: flex-start;
              align-items: center;
              border-bottom: 1px solid rgba(0, 201, 80, 0.20);
              background: rgba(0, 201, 80, 0.05);
              .mint_page_0212311_title0 {
                width: 20%;
                margin: 15px 10px;
                color: #05DF72;
                font-family: Arial;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 20px; /* 142.857% */
              }
              .mint_page_0212311_title1 {
                color: #05DF72;
                font-family: Arial;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 20px; /* 142.857% */
              }
            }
            .rwa_mint_page_0212312s_rows_not_data {
              width: 100%;
              height: 350px;
              text-align: center;
              color: white;
              font-size: 30px;
              font-style: normal;
              font-weight: 600;
              line-height: 350px;
            }
            .rwa_mint_page_0212312s_rows::-webkit-scrollbar {
              width: 0;
              height: 0;
            }
            .rwa_mint_page_0212312s_rows {
              width: 100%;
              height: auto;
              max-height: 350px;
              overflow-y: auto;

              @media (max-width: 767px) {
                height: auto;
                max-height: 500px;
              }
              .rwa_mint_page_0212312s {
                width: 100%;
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                justify-content: flex-start;
                align-items: center;
                border-top: 1px solid rgba(96, 96, 96, 0.20);
                .mint_page_0212312s_row0 {
                  width: 20%;
                  margin: 8px 10px;
                  color: white;
                }
                .mint_page_0212312s_row1 {
                  color: white;
                }
              }
            }
          }
        }
      }
    }
    .rwa_mint_page_03 {
      width: 100%;
    }
  }
}
</style>

<style>
.rwa_mint_div {
  .el-input-number {
    width: 100%;
  }
  .el-input-number__increase {
    background: #363636;
    line-height: 19px !important;
    border-left: 1px solid #616161 !important;
    border-bottom: 1px solid #616161 !important;
  }
  .el-input-number__decrease {
    background: #363636;
    line-height: 19px !important;
    border-left: 1px solid #616161 !important;
  }

  .el-input-number__increase {
    border-left: 1px solid #20944B !important;
    border-bottom: 1px solid #20944B !important;
  }
  .el-input-number__decrease {
    border-left: 1px solid #20944B !important;
  }

  .el-input-number__decrease, .el-input-number__increase {
    color: #cbcbcb !important;
  }

  .el-input__inner {
    color: #c8cbd2 !important;
    background-color: rgba(0, 201, 80, 0.05) !important;
    border: 1px solid #20944B !important;
  }
  .el-input-number__increase.is-disabled, .el-input-number__decrease.is-disabled {
    color: #606266;
  }

  .el-progress-bar {
    border-radius: 10px !important;
    border: 1px solid #20944B !important;

    @media (max-width: 767px) {
      border-radius: 11px !important;
    }
  }
  .el-progress-bar__inner {
    background: linear-gradient( 90deg, #0A2E17 0%, #20944B 100%) !important;
  }
}
</style>